import { RefObject, useEffect } from "react";

/**

Prevents scroll propagation on the specified input element.
@param inputRef - The reference to the input element.
@param scrollSpeed - The speed at which the scroll event is handled. Default is 100 milliseconds. Set 0 to prevent scrolling completely. */

interface UsePreventScrollPropagationProps {
    inputRef: RefObject<HTMLInputElement>;
    scrollSpeed?: number;
    enabled?: boolean;
}

export const usePreventScrollPropagation = ({
    inputRef,
    scrollSpeed = 100,
    enabled = false,
}: UsePreventScrollPropagationProps) => {
    let timeoutId: NodeJS.Timeout | undefined;

    const handleWheel = (event: any) => {
        event.stopPropagation();
        event.preventDefault();

        if (!timeoutId && scrollSpeed > 0) {
            timeoutId = setTimeout(() => {
                if (inputRef.current) {
                    const direction = event.deltaY > 0 ? 1 : -1;
                    inputRef.current.value = String((parseFloat(inputRef.current.value) || 0) + direction);
                    inputRef.current.dispatchEvent(new Event("input", { bubbles: true }));
                }
                timeoutId = undefined;
            }, scrollSpeed);
        }
    };

    useEffect(() => {
        if (!enabled) {
            return;
        }

        if (inputRef.current) {
            inputRef.current.addEventListener("wheel", handleWheel, { passive: false });
        }

        return () => {
            if (inputRef.current) {
                inputRef.current.removeEventListener("wheel", handleWheel);
            }
        };
    }, [inputRef, scrollSpeed]);
};
